module.exports = __webpack_public_path__ + "img/Polar Launch Site.039b30f6.png";